var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TeaserSitecore',{attrs:{"jsonFileName":"teaser5"}}),_c('TeaserSitecore',{attrs:{"jsonFileName":"teaser6"}}),_c('TeaserSitecore',{attrs:{"jsonFileName":"teaser7"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }